module.exports = __webpack_public_path__ + "static/media/card-reader.708757f7.png";